import { useEffect, useState } from 'react';
import { fetchEvmBlock } from '../api/transactions';

export function useEvmBlock(number, chain = null) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const normalized = String(number || '').trim();
    if (!/^(0x[0-9a-fA-F]+|[0-9]+)$/.test(normalized)) {
      setLoading(false);
      setError('Invalid block number.');
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);
    setData(null);

    fetchEvmBlock(normalized, chain)
      .then((result) => {
        if (!cancelled) {
          setData(result);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.response?.data?.message || err.message || 'Block not found.');
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [number, chain]);

  return { data, loading, error, display: data?.display };
}
